import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/authService';
import Notification from '../components/Common/Notification';
import { CircularProgress } from '@mui/material';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(null);

  const isAuthenticated = Boolean(user && user.token);

  const clearNotification = () => setNotification(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    setUser(storedUser ? JSON.parse(storedUser) : null);
    setLoading(false);
  }, []);

  const loginUser = async (credentials) => {
    try {
      const { user, accessToken, refreshToken } = await login(credentials);
      const userData = { ...user, token: accessToken };
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('refreshToken', refreshToken);
      setUser(userData);
      navigate('/');
      return userData;
    } catch (error) {
      console.error('Login error:', error);

      let errorMessage = 'Login Failed.';

      if (error?.response) {
        switch (error.response.status) {
          case 429:
            errorMessage = 'Too many requests. Please try again later.';
            break;
          case 400:
            errorMessage = error.response.data?.error || 'Invalid credentials.';
            break;
          default:
            errorMessage = 'Invalid credentials.';
            break;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      setNotification({
        message: errorMessage,
        isError: true,
      });
      setTimeout(clearNotification, 1000);
    }
  };

  const logoutUser = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    setUser(null);
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <CircularProgress />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loginUser, logoutUser }}>
      {children}
      {notification && (
        <Notification
          message={notification.message}
          isError={notification.isError}
          onClose={clearNotification}
        />
      )}
    </AuthContext.Provider>
  );
};
